import {Injectable, Injector} from "@angular/core";
import {CustomObjectEntityModel} from "./custom-object-entity.model";

@Injectable()
export class ProductLineCustomObjectEntityModel extends CustomObjectEntityModel {
    constructor(injector: Injector) {
        super(injector);
    }

    override getResource(): string {
        return "custom-product-group";
    }
}
